import React from 'react';
import {StyleSheet, View, ViewProps} from 'react-native';

import {ExclamationIcon} from '../../icons/ExclamationIcon';
import {colors} from '../../styles';

export const ValidationError: React.FC<ViewProps> = ({children, style}) => (
  <View style={[styles.container, style]}>
    <ExclamationIcon
      style={styles.icon}
      strokeWidth={2}
      size={16}
      color={colors.black}
    />

    {children}
  </View>
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    gap: 8,
    marginLeft: 2,
  },
  icon: {
    backgroundColor: colors.vividRed,
    borderRadius: 50,
  },
});
